module.exports = __webpack_public_path__ + "static/media/ventia.3401f960.png";